module.exports = __webpack_public_path__ + "static/media/website.80792675.svg";